import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchTracks } from "../lib/api";
import SearchBar from "../components/SearchBar";
import { Horse, MapPin, Users, ArrowRight } from "@phosphor-icons/react";

const TRACK_IMGS = [
  "https://images.pexels.com/photos/1462361/pexels-photo-1462361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/1462398/pexels-photo-1462398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function TracksPage() {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTracks()
      .then(setTracks)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="tracks-page" className="min-h-screen bg-white">
      <header className="border-b border-border px-4 md:px-8 py-4 flex items-center justify-between gap-4 flex-wrap">
        <Link to="/" className="flex items-center gap-2">
          <Horse weight="fill" size={28} className="text-[#E12B00]" />
          <span className="text-lg font-heading font-black tracking-tight text-zinc-900">Racing Form Guide</span>
        </Link>
        <SearchBar />
        <nav className="flex items-center gap-4 text-xs font-mono uppercase tracking-wider">
          <Link to="/" data-testid="nav-home-tracks" className="text-zinc-500 hover:text-zinc-900 transition-colors">Live</Link>
          <Link to="/tracks" data-testid="nav-tracks-active" className="text-zinc-900 font-bold hover:text-[#E12B00] transition-colors">Tracks</Link>
        </nav>
      </header>

      <main className="p-4 md:p-8 max-w-[1400px] mx-auto">
        <div className="flex items-center gap-2 mb-6">
          <MapPin weight="bold" size={16} className="text-zinc-400" />
          <p className="mono-label text-zinc-500">UK Racecourses ({tracks.length})</p>
        </div>

        {loading ? (
          <div className="py-12 text-center">
            <p className="mono-label text-zinc-400">Loading tracks...</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {tracks.map((track, i) => (
              <Link
                key={track.id}
                to={`/track/${track.id}`}
                data-testid={`track-card-${track.id}`}
                className="group border border-border overflow-hidden hover:border-zinc-400 transition-colors"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={TRACK_IMGS[i % TRACK_IMGS.length]}
                    alt={track.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="text-lg font-heading font-bold text-white">{track.name}</h3>
                    <p className="text-xs text-zinc-300 font-mono">{track.location}</p>
                  </div>
                </div>
                <div className="p-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 text-xs text-zinc-500">
                      <span className="font-mono">{track.surface}</span>
                      <span className="flex items-center gap-1">
                        <Users weight="bold" size={12} />
                        {track.capacity?.toLocaleString()}
                      </span>
                    </div>
                    <ArrowRight weight="bold" size={14} className="text-zinc-300 group-hover:text-[#E12B00] transition-colors" />
                  </div>
                  <p className="text-xs text-zinc-400 mt-2 line-clamp-2">{track.description}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
